
import { defineComponent } from "vue";
import { Post } from "@/types/interfaces";

export default defineComponent({
  name: "PostList",

  props: ["posts", "currentPost"],

  methods: {
    setCurrentItem(id: string) {
      const currentPost = this.$props.posts.filter((post: Post) => post.id === id)[0];
      this.$emit("update:currentPost", currentPost);
    },

    setShortDescription(text: string, max: number) {
      const regex = /(<([^>]+)>)/gi;
      if (text && text.length > max) {
        return text.replace(regex, "").slice(0, max);
      }
      if (text) {
        return text.replace(regex, "");
      }
      return "";
    },
  },
});
